import { EyeClosedIcon, EyeOpenIcon } from "@radix-ui/react-icons";
import { Button, Flex, TextField } from "@radix-ui/themes";
import React, { useState } from "react";



export default function PasswordInput(props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) 
{
    const [visible, setVisible] = useState<boolean>(false)
    return (
        <Flex align={'start'} justify={'start'} gap={'2'}> 
        <TextField.Root className="container" type={visible ? 'text' : 'password'} {...props}>
            
        </TextField.Root>
        <Button onClick={() => setVisible(!visible)}> 
        {
        visible ? 
        <EyeOpenIcon />
        :
        <EyeClosedIcon />
        
        }
        </Button>
        </Flex> 
    )
}